import tinymce from 'tinymce';

import 'tinymce/icons/default/icons.min';
import 'tinymce/themes/silver/theme.min';
import 'tinymce/models/dom/model';
import 'tinymce/plugins/link/plugin.min';
import 'tinymce/plugins/lists/plugin.min';
import 'tinymce/plugins/table/plugin.min';
import 'tinymce/plugins/autoresize/plugin.min';

class TextEditor {
    constructor(selector, options = {}, autoInit = true) {
        this.selectorOrElement = selector;
        this.instance = null;
        this.options = options;

        if (autoInit) {
            this.init();
        }
    }

    init() {
        if (typeof this.selectorOrElement === 'string') {
            document.querySelectorAll(this.selectorOrElement)
                .forEach((element) => this.bootElement(element));

            return;
        }

        this.bootElement(this.selectorOrElement);
    }

    bootElement(element) {
        if (! element.hasAttribute('id')) {
            element.setAttribute('id', `text-editor-${Math.random().toString(36)}`);
        }

        tinymce.init({
            license_key: 'gpl',
            suffix: '.min',
            skin_url: '/css/tinymce/skins/ui/oxide',
            paste_as_text: true,
            toolbar_mode: 'sliding',
            menubar: false,
            statusbar: false,
            link_title: false,
            link_target_list: false,
            content_css: false,
            link_default_target: '_blank',
            link_assume_external_targets: 'https',
            target: element,
            plugins: [
                'link',
                'lists',
                'table',
            ],
            highlight_on_focus: false,
            toolbar:
                `fontfamily fontsize forecolor |
                 undo redo |
                 bold italic underline |
                 alignleft aligncenter alignright |
                 link unlink |
                 indent outdent |
                 removeformat strikethrough subscript superscript |
                 numlist bullist |
                 table`,
            ...this.options,
            setup: (editor) => {
                this.instance = editor;

                editor.on('init', () => {
                    console.log('setup -> init editor', element, this.instance);
                });
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new textEditor('.text-editor');
}, false);

window.textEditor = TextEditor;
window.tinymce = tinymce;
